export const conversationRouteNames = {
  conversationsV2: 'conversations-v2',
  conversationsIdV2: 'conversations-id-v2',
  manualActions: 'manual-actions-v2',
  conversationsTemplate: 'conversations-templates-v2',
  triggerLinksConversationsV2: 'triggers-links-conversations-v2',
  triggersLinksLinkConversationsV2: 'triggers-links-link-conversations-v2',
  triggersLinksAnalyzeConversationsV2: 'triggers-links-analyze-conversations-v2',
}